export const version = "properties/5.2.0";
